import { render, staticRenderFns } from "./ResiAgen.vue?vue&type=template&id=9862979e&scoped=true"
import script from "./ResiAgen.vue?vue&type=script&lang=js"
export * from "./ResiAgen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9862979e",
  null
  
)

export default component.exports